const logos = [
  { name: 'Andela', src: '/images/logos/andela.jpeg' },
  { name: 'Flutterwave', src: '/images/logos/flutterwave.jpeg' },
  { name: 'Moove', src: '/images/logos/moove.jpeg' },
  { name: 'Stitch', src: '/images/logos/stitch.jpeg' },
  { name: 'Bamboo', src: '/images/logos/bamboo.jpeg' },
];

export default function Marquee() {
  return (
    <div
      className="w-full overflow-hidden py-3 pointer-events-none"
      style={{ background: 'rgba(9,26,22,.6)', backdropFilter: 'blur(8px)', borderTop: '1px solid rgba(255,252,238,.04)' }}
      data-testid="portfolio-marquee"
    >
      <div className="marquee-track flex items-center gap-14 px-4">
        {[...logos, ...logos, ...logos, ...logos].map((logo, i) => (
          <img
            key={i}
            src={logo.src}
            alt={logo.name}
            className="h-5 w-auto select-none pointer-events-none flex-shrink-0"
            style={{ filter: 'grayscale(100%) brightness(2) contrast(0.8)', opacity: 0.15 }}
            draggable={false}
          />
        ))}
      </div>
    </div>
  );
}
